module.exports = __webpack_public_path__ + "26d9532036714b43c61f8d06598bbaa0.woff2";